import { type FleetAction, FleetActionNames } from './actions';

import { type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

interface FleetState {
  urlLogoWebData: WebData<string | null>;
}

export const fleetInitialState: FleetState = {
  urlLogoWebData: webDataNotAsked(),
};

export const fleetReducer = (state: FleetState = fleetInitialState, action: FleetAction): FleetState => {
  if (!(action.type in FleetActionNames)) {
    return state;
  }

  switch (action.type) {
    case FleetActionNames.LOAD_FLEET_LOGO_URL_REQUEST:
      return {
        ...state,
        urlLogoWebData: webDataFetching(),
      };

    case FleetActionNames.LOAD_FLEET_LOGO_URL_SUCCEEDED:
      return {
        ...state,
        urlLogoWebData: webDataSuccess(action.payload),
      };

    case FleetActionNames.LOAD_FLEET_LOGO_URL_FAILED:
      return {
        ...state,
        urlLogoWebData: webDataError(),
      };

    default:
      return state;
  }
};
